import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Position the wrapper absolutely against the parent row so the column floats above its siblings.
   * Combine with image-backed Layout Rows to overlay text on top.
   *
   * @type {Boolean|String}
   * @default undefined
   */
  foreground: booleanAttribute(undefined),
  /**
   * Debug label rendered in the top-right corner of the column when show-label is set. Useful for
   * visualising Layout Builder columns during authoring.
   *
   * @type {String}
   * @default undefined
   */
  label: {
    type: String,
    default: undefined,
  },
  /**
   * Show the debug label badge.
   *
   * @type {Boolean|String}
   * @default false
   */
  showLabel: booleanAttribute(),
});
